<template>
  <div class="common-input">
    <input class="input-div" :type="type" :placeholder="placeholder" v-model="VaLue" ref="commonInput" @search="searchinput" @input="OnInput" @keypress="inputkeypress" @focus="inputfocus" @blur="inputblur" :disabled="disabled" :maxLength="maxLength" :style="{'text-align' :textalign,'color':color,'font-size':fontSize,'font-weight':fontWeight}" />
    <div class="right-search-icon" v-show="clearshow && VaLue" @click="claerInput">
      <img :src="clearicon" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        require: true
      },
      placeholder: {
        type: String,
        default: '请输入内容'
      },
      searchiconshow: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'text'
      },
      textalign: {
        type: String,
        default: 'left'
      },
      color: {
        type: String,
        default: '#333'
      },
      fontSize: {
        type: String,
        default: '15px'
      },
      fontWeight: {
        type: Number,
        default: 100
      },
      dointLimit: {
        type: String,
        default: 'none'
      },
      clearshow: {
        type: Boolean,
        default: false
      },
      maxLength: { //元素属性-只对字符串有用
        type: Number,
        default: null,
      },
    },
    watch: {
      value(newval, oldval) {
        this.VaLue = newval
      }
    },
    data() {
      return {
        leftrightstatus: false,
        VaLue: '',
        clearicon: require('@/assets/recharge/input-clear-icon.png')
      }
    },
    created() {
      this.VaLue = this.value
    },
    methods: {
      inputkeypress(event) {
        if (event.keyCode == 13) {
          //如果按的是enter键 13是enter
          event.preventDefault(); //禁止默认事件（默认是换行）
          this.$refs.commonInput.blur();
          this.$emit('keypress')
        }
      },
      OnInput(e) {
        if (this.VaLue == '') {
          this.leftrightstatus = false
        } else {
          this.leftrightstatus = true
        }
        if (this.VaLue.length == this.maxLength + 1 && this.type == 'number') {
          this.VaLue = e.target._value
        }
        if (this.dointLimit != 'none' && !isNaN(this.dointLimit)) {
          let valueList = this.VaLue.split('.')
          if (valueList.length > 1 && valueList[1].length >= 2) {
            this.VaLue = valueList[0] + '.' + valueList[1].substring(0, Number(this.dointLimit))
          }
        }
        this.$emit('update:value', this.VaLue);
        this.$emit('input', this.VaLue)
      },
      // 搜索框正在搜索
      searchinput() {
        this.$emit('search', this.VaLue)
      },
      inputfocus() {
        if (this.VaLue == '') {
          this.leftrightstatus = false
        } else {
          this.leftrightstatus = true
        }
        this.$emit('focus')
      },
      // 失焦事件
      inputblur() {
        if (this.VaLue == '') {
          this.leftrightstatus = false
        }
        if (this.dointLimit != 'none') {
          let valueList = this.VaLue.split('.')
          if (valueList.length > 1 && valueList[1].length >= 2) {} else if (valueList.length > 1 && valueList[1].length == 1) {
            this.VaLue = String(valueList[0] + '.' + valueList[1] + '0')
            this.$emit('update:value', this.VaLue);
          } else {
            let calcValue = '.'
            for (let i = 0; i < this.dointLimit; i++) {
              calcValue += '0'
            }
            this.VaLue = String(Number(valueList[0]) + calcValue)
            this.$emit('update:value', this.VaLue);
          }
        }
        this.$emit('blur')
      },
      claerInput() {
        if (this.VaLue == '') {
          return
        }
        this.VaLue = ''
        this.$emit('update:value', '');
        this.leftrightstatus = false
        this.$emit('clear')
      },
      clickinput() {
        this.$emit('clickinput')
      }
    }
  }
</script>

<style lang="less" scoped>
  .common-input {
    position: relative;
    display: flex;
    box-sizing: border-box;
    overflow: hidden;
    color: #323233;
    border-radius: 999px;
    height: 100%;

    .input-div {
      display: inline-block;
      box-sizing: border-box;
      font-size: 15px;
      width: auto;
      min-width: 0;
      width: 100%;
      min-height: 21px;
      margin: 0;
      padding: 0;
      color: #323233;
      line-height: inherit;
      text-align: left;
      background-color: transparent;
      border: 0;
      resize: none;
      // position: relative;
      // top: 50%;
      // transform: translateY(-50%);

      &::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: #cccccc;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }

      &::-webkit-search-cancel-button {
        -webkit-appearance: none;
      }

      &::-ms-clear,
      &::-ms-reveal {
        display: none;
      }

      &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #cccccc;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }

      &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #cccccc;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #cccccc;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;

      }
    }

    .right-search-icon {
      padding: 0 12px 0 12px;

      position: relative;
      // top: 50%;
      // transform: translateY(-50%);

      img {
        position: absolute;
        bottom: 4px;
        right: 12px;
        object-fit: contain;
        width: 18px;
        height: 18px;
        object-fit: contain;
      }

    }
  }
</style>